import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { NavLink } from "react-router-dom";
import PlaylistProgressBar from "./playlist_progress_bar/PlaylistProgressBar";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import { DoneOutline } from "@mui/icons-material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { useStyles } from "./PlaylistCardStyles.css";
import { FormattedMessage } from "react-intl";

/**
 * Component used to represent a single playlist within the course playlist view
 */

const PlaylistCard = ({ playlist, course }) => {
    const classes = useStyles();

    return (
        <Card sx={{ maxWidth: 350 }} style={{ minHeight: 320, maxHeight: 350 }}>
            <NavLink
                to={{
                    pathname: "/game/session",
                    state: {
                        playlistName: playlist.name,
                        scoredSceneCount: playlist.scoredScenesKeys.length,
                        courseId: course.key,
                        playlistId: playlist.key,
                        scoredSceneId: undefined,
                        isReplay: false,
                        feedbackMode: playlist.feedbackMode,
                    },
                }}
                style={{ textDecoration: "none" }}
            >
                <CardHeader title={playlist.name} />
            </NavLink>

            <CardContent style={{ height: 200, overflow: "auto" }}>
                {playlist.percentageInfo.completedOnce === true ? (
                    <div className={classes.completionInfoContainer}>
                        <DoneOutlineIcon
                            fontSize="large"
                            className={classes.completionStatusIcon}
                        />
                        <div className={classes.completionStatusText}>
                            <FormattedMessage
                                id={"app.game.playlist.card.completion.status.completed"}
                                defaultMessage={"You have completed this playlist once. "}
                            />{" "}
                        </div>
                    </div>
                ) : (
                    <div className={classes.completionInfoContainer}>
                        <HourglassBottomIcon
                            fontSize="large"
                            className={classes.completionStatusIcon}
                        />
                        <div className={classes.completionStatusText}>
                            <FormattedMessage
                                id={"app.game.playlist.card.completion.status.progress"}
                                defaultMessage={"This playlist is in progress. "}
                            />
                        </div>
                        <br />
                    </div>
                )}
                <span>
                    <FormattedMessage
                        id={"app.game.playlist.card.completion.current.attempt"}
                        defaultMessage={"Current attempt: "}
                    />{" "}
                    {playlist.percentageInfo.currentRunCount}/
                    {playlist.scoredScenesKeys.length}
                </span>
                <PlaylistProgressBar
                    completed={Math.trunc(playlist.percentageInfo.percentage)}
                />
            </CardContent>
        </Card>
    );
};

export default PlaylistCard;
